<template lang="pug">
.page.no-select(:class="mode")
  router-view.color_bg_2
</template>
<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import eventBus from '@/utils/eventBus';

export default {
  name: 'App',
  components: {},
  setup() {
    const mode = ref('light');
    const store = useStore();
    const isDark = navigator.userAgent.indexOf('YDUIStyle/Dark') > -1;
    if (isDark) {
      mode.value = 'dark';
    }
    store.dispatch('setAppMode', mode.value);
    document.body.className = mode.value;
    window.setYDUIStyle = (m) => {
      mode.value = m;
      // 发出暗夜模式切换通知
      eventBus.$emit('dictUIModeChange', m);
      store.dispatch('setAppMode', m);
      if (m === 'dark') {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    };

    onMounted(() => {
      /* eslint-disable */
      window.ydk.getClientInfo({
        success (res) {
          window._rlog.push(['_addPost', 'imei', res.imei]);
        },
        complete () {
          window._rlog.push(['_trackCustom', 'japanese50', [['action', 'pageview']]]);
        }
      })
    });

    return {
      mode,
    };
  },
};
</script>
<style lang="stylus">
  @import './styles/reset.styl'
  @import './styles/UIKibrary.css'
  body.light {
    background #ffffff;
  }
  body.dark {
    background #141517;
  }
  #app {
    max-width 9.6rem;
    margin: 0 auto;
  }
  .page{
    box-sizing border-box
    min-height: 100%;
  }
  .overflow-hidden {
    width 100%
    overflow hidden
    position fixed
  }
  .no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
  }
</style>
<style>
  @-webkit-keyframes audioPlaying {
    0% { background-image: url("./assets/ic_result_voice_00.png") }
    30% { background-image: none}
    60% { background-image: url("./assets/ic_result_voice_02.png") }
    100% { background-image: url("./assets/ic_result_voice_00.png") }
  }
  @-webkit-keyframes audioPlaying {
    0% { background-image: url("./assets/ic_result_voice_00.png") }
    30% { background-image: none }
    60% { background-image: url("./assets/ic_result_voice_02.png") }
    100% { background-image: url("./assets/ic_result_voice_00.png") }
  }
  @-webkit-keyframes audioPlayingDark {
    0% { background-image: url("./assets/ic_result_voice_00_dark.png") }
    30% { background-image: none }
    60% { background-image: url("./assets/ic_result_voice_02_dark.png") }
    100% { background-image: url("./assets/ic_result_voice_00_dark.png") }
  }
  @-webkit-keyframes audioPlayingDark {
    0% { background-image: url("./assets/ic_result_voice_00_dark.png") }
    30% { background-image: none }
    60% { background-image: url("./assets/ic_result_voice_02_dark.png") }
    100% { background-image: url("./assets/ic_result_voice_00_dark.png") }
  }
</style>
